import { getCurrentTime } from "sb-resp-utils";
import { DateFromISO, TypeExtends } from "sb-js-extends";
DateFromISO();
TypeExtends();
export const formatDateTime = (config, startEventDate) => {
    const dateIso = Date.fromISO(startEventDate);
    if (!dateIso) {
        return "";
    }
    return `${formatDate(config.dict, dateIso)} ${dateIso.formatDate(config.cmsConfig.timeFormat)}`;
};
export const getISODate = (dateISOString, currentTimeZone) => {
    return getCurrentTime(new Date(dateISOString), currentTimeZone).toISOString();
};
const formatDate = (dict, dateIso) => {
    const dayOfWeek = weekDaysMapper(dict)[dateIso.getDay()];
    const date = dateIso.getDate();
    const month = monthsMapper(dict)[dateIso.getMonth()];
    return `${dayOfWeek}, ${date} ${month}`;
};
const monthsMapper = (dict) => {
    return [
        dict.January,
        dict.February,
        dict.March,
        dict.April,
        dict.May,
        dict.June,
        dict.July,
        dict.August,
        dict.September,
        dict.October,
        dict.November,
        dict.December
    ];
};
const weekDaysMapper = (dict) => {
    return [
        dict.Sunday,
        dict.Monday,
        dict.Tuesday,
        dict.Wednesday,
        dict.Thursday,
        dict.Friday,
        dict.Saturday
    ];
};
//# sourceMappingURL=formatDateTime.js.map